import React from "react";
import { useLocation } from "react-router-dom";

const BOOKING_URL_EN = "/book-a-meeting";
const BOOKING_URL_FR = "/fr/prendre-rendez-vous";

export default function FloatingScheduleCallButton() {
  const location = useLocation();
// hide button on pages
  const hideOnRoutes = [
    "/sign-in",
    "/apply/vtc",
    "/apply/life",
    "/quote/vtc",
    "/quote/vtc/quote-comparison-tool",


  ];

  const shouldHide = hideOnRoutes.some(
    (route) => location.pathname === route || location.pathname === route + "/"
  );

  if (shouldHide) return null;

  const isFrench = location.pathname.startsWith("/fr");

  return (
    <a
      href={isFrench ? BOOKING_URL_FR : BOOKING_URL_EN}
      target="_blank"
      rel="noopener noreferrer"
      className="
        fixed left-1/2 -translate-x-1/2
        bottom-16 sm:bottom-12
        z-[9996]
        rounded-full
        bg-[#11b7ea]
        px-6 py-2
        text-[#0a2540]
        text-[14px] sm:text-[18px]
        font-semibold
        shadow-[0_14px_30px_rgba(0,0,0,0.28)]
        hover:bg-[#0ea4d2]
        transition-colors
      "
    >
      {isFrench ? "Planifier un appel" : "Schedule a Call"}
    </a>
  );
}
